export const errorPageNamespace = 'error-page';
